export const APP_BASE_URL = 'https://fapi.faraad.org/api';
export const IMAGE_BASE_URL = 'https://fapi.faraad.org/photoes';
export const VIDEO_BASE_URL = 'https://faraad.org/video';
export const EXAMINATION_VIDEO_BASE_URL = 'https://faraad.org/voice';
//export const URL_TO_BANK_PAYMENT = 'https://fapi.faraad.org/api/prepare_the_purchase?token=';
export const URL_TO_BANK_PAYMENT = 'https://api.medme.clinic/api/prepare_the_purchase?token=';
//export const URL_TO_BANK_PAYMENT_VISIT = 'https://fapi.faraad.org/api/buy_visit?token=';
export const URL_TO_BANK_PAYMENT_VISIT = 'https://api.medme.clinic/api/buy_visit?token=';
